import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import VinWonderTicketDetail from './VinWonderTicketDetail';
import * as vinWonderTicketActions from './../../../../../actions/vinWonderTicketAction';
import * as vinWonderActions from './../../../../../actions/vinWonderAction';

const mapStateToProps = state => {
    return {
        vinWonderTicketState: state.vinWonderTicketReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onGetUpdate: (id) => dispatch(vinWonderActions.getUpdateVinWonderAction(id)),
        getVinWonderTicketDetail: (id) => dispatch(vinWonderTicketActions.getVinWonderTicketDetail(id)),
        setVinWonderTicketDetail: (vinWonderTicket) => dispatch(vinWonderTicketActions.setVinWonderTicketDetail(vinWonderTicket)),
        updateVinWonderTicketDetail: (vinWonderTicket) => dispatch(vinWonderTicketActions.updateVinWonderTicketDetail(vinWonderTicket)),
        createVinWonderTicketDetail: (vinWonderTicket) => dispatch(vinWonderTicketActions.createVinWonderTicketDetail(vinWonderTicket)),
        createVinWonderTicketTranslate: (vinWonderTicket, language) => dispatch(vinWonderTicketActions.createVinWonderTicketTranslate(vinWonderTicket, language)),
        updateVinWonderTicketTranslate: (vinWonderTicket, language) => dispatch(vinWonderTicketActions.updateVinWonderTicketTranslate(vinWonderTicket, language)),
        deleteVinWonderTicketTranslate: (vinWonderTicket, refreshParams) => dispatch(vinWonderTicketActions.deleteVinWonderTicketTranslate(vinWonderTicket, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(VinWonderTicketDetail));
